export default __webpack_public_path__ + "static/media/empty_avatar.85ea1465.jpg";